import React, { useEffect, useRef } from 'react'
import { Button } from 'react-bootstrap'
import EditIcon from '../../../../components/icons/EditIcon'
import CheckIcon from '../../../../components/icons/CheckIcon'
import CloseIcon from '../../../../components/icons/CloseIcon'

interface ConsignmentItemInlineEditCellProps {
  isEditing: boolean
  draft: string
  isSaving: boolean
  editDisabled: boolean
  label: string
  type: 'text' | 'number'
  onStartEditing: () => void
  onDraftChange: (value: string) => void
  onSave: () => void
  onCancel: () => void
  children: React.ReactNode
}

function ConsignmentItemInlineEditCell({
  isEditing,
  draft,
  isSaving,
  editDisabled,
  label,
  type,
  onStartEditing,
  onDraftChange,
  onSave,
  onCancel,
  children,
}: ConsignmentItemInlineEditCellProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus()
    }
  }, [isEditing])

  const stopPropagation = (event: React.MouseEvent) => event.stopPropagation()

  if (isEditing) {
    return (
      <div className="inline-edit">
        <input
          ref={inputRef}
          type={type}
          className={`form-control form-control-sm goods-inline-input${type === 'number' ? ' goods-inline-input--number' : ''}`}
          value={draft}
          aria-label={label}
          disabled={isSaving}
          onChange={(e) => onDraftChange(e.target.value)}
          onClick={stopPropagation}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              onSave()
            }
            if (e.key === 'Escape') {
              e.preventDefault()
              onCancel()
            }
          }}
        />
        <div className="inline-edit__controls" onClick={stopPropagation} role="presentation">
          <Button
            type="button"
            variant="link"
            className="btn-icon"
            onClick={onCancel}
            disabled={isSaving}
          >
            <CloseIcon />
          </Button>
          <Button
            type="button"
            variant="link"
            className="btn-save"
            onClick={onSave}
            disabled={isSaving}
          >
            <CheckIcon />
          </Button>
        </div>
      </div>
    )
  }

  if (editDisabled) {
    return <div className="inline-edit inline-edit--display">{children}</div>
  }

  return (
    <button
      type="button"
      className="inline-edit inline-edit--display inline-edit__trigger"
      onClick={(event) => {
        event.stopPropagation()
        onStartEditing()
      }}
      aria-label={`${label}: edit`}
    >
      {children}
      <EditIcon className="inline-edit__pencil" />
    </button>
  )
}

export default ConsignmentItemInlineEditCell
